<template>
  <div
    class="card__quick-actions forced-pointer-events-auto"
    @mousedown.stop
    @click.stop
  >
    <a
      v-for="field in quickSetFields"
      :key="'quick-set-' + field.id"
      v-tooltip="field.name"
      class="card__quick-action forced-pointer-events-auto"
      @mousedown.stop
      @click.stop.prevent="toggle(field, $event)"
    >
      <i :class="fieldIcon(field)"></i>
    </a>
    <Context
      ref="context"
      :overflow-scroll="true"
      :max-height-if-outside-viewport="true"
    >
      <div v-if="activeField" class="card__quick-actions-context">
        <component
          :is="getFieldComponent(activeField)"
          :field="activeField"
          :value="row['field_' + activeField.id]"
          :read-only="false"
          :workspace-id="database.workspace.id"
          :row="row"
          :all-fields-in-table="fields"
          @update="update"
        />
      </div>
    </Context>
  </div>
</template>

<script>
/**
 * Origem Flow: quick-set estilo ClickUp — ícones de hover no card do kanban
 * que permitem editar campos (status, prioridade, responsável, data...) sem
 * abrir o modal da linha. O Context é teleportado para o body, então não é
 * afetado pelo `pointer-events: none` dos filhos do card; os gatilhos furam
 * a regra com `forced-pointer-events-auto` + `@mousedown.stop`, o mesmo par
 * usado por RowCardFieldButton.
 */
import Context from '@baserow/modules/core/components/Context'
import { notifyIf } from '@baserow/modules/core/utils/error'

const QUICK_SET_FIELD_TYPES = [
  'single_select',
  'multiple_select',
  'multiple_collaborators',
  'date',
  'rating',
  'boolean',
]
const MAX_QUICK_SET_FIELDS = 4

export default {
  name: 'KanbanCardQuickSet',
  components: { Context },
  props: {
    row: {
      type: Object,
      required: true,
    },
    cardFields: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    database: {
      type: Object,
      required: true,
    },
    table: {
      type: Object,
      required: true,
    },
    view: {
      type: Object,
      required: true,
    },
    storePrefix: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activeField: null,
    }
  },
  computed: {
    quickSetFields() {
      return this.cardFields
        .filter((field) => {
          if (!QUICK_SET_FIELD_TYPES.includes(field.type)) {
            return false
          }
          const fieldType = this.$registry.get('field', field.type)
          return fieldType.canWriteFieldValues(field)
        })
        .slice(0, MAX_QUICK_SET_FIELDS)
    },
  },
  methods: {
    fieldIcon(field) {
      return this.$registry.get('field', field.type).iconClass
    },
    getFieldComponent(field) {
      return this.$registry
        .get('field', field.type)
        .getRowEditFieldComponent(field)
    },
    toggle(field, event) {
      const target = event.currentTarget
      if (this.activeField !== null && this.activeField.id === field.id) {
        this.$refs.context.toggle(target, 'bottom', 'left', 4)
        return
      }
      this.activeField = field
      this.$nextTick(() => {
        this.$refs.context.show(target, 'bottom', 'left', 4)
      })
    },
    async update(value, oldValue) {
      const field = this.activeField
      this.$refs.context.hide()
      try {
        await this.$store.dispatch(
          this.storePrefix + 'view/kanban/updateRowValue',
          {
            table: this.table,
            view: this.view,
            fields: this.fields,
            row: this.row,
            field,
            value,
            oldValue,
          }
        )
      } catch (error) {
        notifyIf(error, 'field')
      }
    },
  },
}
</script>
